import { valuePropCarouselAlt as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';
import { ValuePropCarouselAltProps } from '.';

const TestData: ValuePropCarouselAltProps = {
  eyebrow: 'Our Culture',
  header: 'What sets us apart and keeps us together.',
  backgroundColor: false,
  valuePropCardContentAlt: [
    {
      cardImage: '/assets/carouselTest/test_01.jpg',
      cardHeadline: 'A Smarter Approach to Marketing Listings',
      cardSubHeadline: '',
      cardDescription:
        'MaX delivers a unique marketing strategy for every listing. Engel & Völkers advisors can create a unique data-driven marketing strategy in their listing presentations based on the local market, target buyers and listing price.',
      links: [
        {
          metadata: {
            tags: [],
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: '3g4b24b0tvoz',
              },
            },
            id: '1La6Htvn71eFTBhdr3TZQk',
            type: 'Entry',
            createdAt: '2024-05-07T14:15:58.999Z',
            updatedAt: '2024-05-07T14:15:58.999Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment',
              },
            },
            revision: 1,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'linkDownload',
              },
            },
            locale: 'en-US',
          },
          fields: {
            text: 'Value Prop Carousel ALT Download Link Test 1',
            downloadableAsset: {
              metadata: {
                tags: [],
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: '3g4b24b0tvoz',
                  },
                },
                id: '4eLBcWJPqMYbhm5m3EeM0e',
                type: 'Asset',
                createdAt: '2024-05-07T14:36:56.115Z',
                updatedAt: '2024-05-07T14:36:56.115Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment',
                  },
                },
                revision: 1,
                locale: 'en-US',
              },
              fields: {
                title: 'Value Prop Carousel ALT Test',
                description: '',
                file: {
                  url: '//assets.ctfassets.net/3g4b24b0tvoz/4eLBcWJPqMYbhm5m3EeM0e/208944d1ae1696d801e5b5124aaebb07/ValuePropCarouselALT_test.pdf',
                  details: {
                    size: 95355,
                  },
                  fileName: 'ValuePropCarouselALT_test.pdf',
                  contentType: 'application/pdf',
                },
              },
            },
          },
        },
      ],
    },
    {
      cardImage: '/assets/carouselTest/test_02.jpg',
      cardHeadline: 'Bespoke Experience',
      cardSubHeadline: '',
      cardDescription: 'Luxury is more than an object or property, but rather, the fullness.',
      links: [
        {
          metadata: {
            tags: [],
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: '3g4b24b0tvoz',
              },
            },
            id: '308TVKIwtkggqzzIEguapg',
            type: 'Entry',
            createdAt: '2024-05-07T14:15:58.949Z',
            updatedAt: '2024-05-07T14:15:58.949Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment',
              },
            },
            revision: 1,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'link',
              },
            },
            locale: 'en-US',
          },
          fields: {
            text: 'Learn More',
            url: '#',
            external: false,
          },
        },
      ],
    },
    {
      cardImage: '/assets/carouselTest/test_03.jpg',
      cardHeadline: 'Global Network',
      cardSubHeadline: '',
      cardDescription: 'Luxury is more than an object or property, but rather, the fullness.',
      links: [
        {
          metadata: {
            tags: [],
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: '3g4b24b0tvoz',
              },
            },
            id: '33HIqLEnqiWoPapbJB6IiO',
            type: 'Entry',
            createdAt: '2024-05-07T14:15:58.896Z',
            updatedAt: '2024-05-07T14:15:58.896Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment',
              },
            },
            revision: 1,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'link',
              },
            },
            locale: 'en-US',
          },
          fields: {
            text: 'Learn More',
            url: '#',
            external: true,
          },
        },
      ],
    },
    {
      cardImage: '/assets/carouselTest/test_04.jpg',
      cardHeadline: 'Reclaimed luxury',
      cardSubHeadline: '',
      cardDescription: 'Luxury is more than an object or property, but rather, the fullness.',
      links: [
        {
          metadata: {
            tags: [],
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: '3g4b24b0tvoz',
              },
            },
            id: '33HIqLEnqiWoPapbJB6IiO',
            type: 'Entry',
            createdAt: '2024-05-07T14:15:58.896Z',
            updatedAt: '2024-05-07T14:15:58.896Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment',
              },
            },
            revision: 1,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'link',
              },
            },
            locale: 'en-US',
          },
          fields: {
            text: 'Learn More',
            url: '#',
            external: true,
          },
        },
      ],
    },
  ],
};

export default fakeProps(schema, TestData);
